<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import ActionPreview from '../components/GenericView/ActionPreview.svelte';
	import SectionContainer from '../components/GenericView/SectionContainer.svelte';
	import { normalizeSceneDoStatements } from '../../Flows/converters/flow-island-utils';

	export let thens = [];

	const dispatch = createEventDispatcher();

	$: list = normalizeSceneDoStatements(thens);
</script>

{#each list as element, index}
	<SectionContainer class={list.length - 1 > index ? 'mb-s' : ''}>
		<ActionPreview
			{element}
			on:edit-do={() => {
				dispatch('edit-do', index);
			}}
		/>
	</SectionContainer>
{/each}
